export const customerFulfillmentData = {
  "This Month": [765, 795, 960, 495, 495, 660, 615],
  "Last Month": [680, 221, 884, 629, 731, 272, 612],
};
